
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12zm11.983-3.19c.975 0 1.632.422 2.007.775l1.466-1.433c-.9-.838-2.071-1.352-3.473-1.352a5.188 5.188 0 00-4.639 2.866A5.21 5.21 0 006.79 12c0 .838.202 1.63.554 2.334l1.685-1.306-1.68 1.306a5.18 5.18 0 004.634 2.866c1.402 0 2.579-.462 3.438-1.26.981-.907 1.547-2.241 1.547-3.824 0-.428-.035-.74-.11-1.064h-4.875v1.93h2.861c-.057.48-.369 1.202-1.061 1.687-.439.307-1.027.52-1.8.52-1.373 0-2.539-.907-2.954-2.16A3.205 3.205 0 018.856 12c0-.358.063-.705.167-1.028.421-1.254 1.587-2.161 2.96-2.161z","fill":"currentColor"}})])
          )
        }
      }
    